import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {InsolesSummaryModel} from '../../../api/model/insolesSummary.model';
import {InsolesSummaryConverter} from '../../../api/model/insolesSummary.converter';
import {InsolesModel} from '../../../api/model/insoles.model';
import {InsolesDataService} from './insoles.data.service';

@Injectable()
export class InsolesSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    InsolesSummaryModel,
    InsolesSummaryConverter,
    InsolesModel> {
    constructor(dataService: InsolesDataService, converter: InsolesSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): InsolesModel {
        return new InsolesModel();
    }
}
